import { SafeAreaProviderCompat } from "@react-navigation/elements";
import {
  createNavigatorFactory,
  type DefaultNavigatorOptions,
  type EventMapBase,
  type ParamListBase,
  type StackActionHelpers,
  type StackNavigationState,
  StackRouter,
  type StackRouterOptions,
  useNavigationBuilder,
} from "@react-navigation/native";
import type {
  NativeStackDescriptorMap,
  NativeStackNavigationEventMap,
  NativeStackNavigationHelpers,
  NativeStackNavigationOptions,
} from "@react-navigation/native-stack/lib/typescript/src/types";

type PlainScreenViewProps = {
  state: StackNavigationState<ParamListBase>;
  // This is used for the native implementation of the stack.
  // eslint-disable-next-line react/no-unused-prop-types
  navigation: NativeStackNavigationHelpers;
  descriptors: NativeStackDescriptorMap;
};

const PlainScreenView: React.FC<PlainScreenViewProps> = ({
  state,
  descriptors,
}) => {
  const currentRouteKey = state.routes[state.index].key;
  const { render } = descriptors[currentRouteKey];

  return <SafeAreaProviderCompat>{render()}</SafeAreaProviderCompat>;
};

type PlainScreenNavigatorProps = DefaultNavigatorOptions<
  ParamListBase,
  // biome-ignore lint/suspicious/noExplicitAny: Not sure what it should be
  any,
  // biome-ignore lint/suspicious/noExplicitAny: Not sure what it should be
  any,
  EventMapBase,
  // biome-ignore lint/suspicious/noExplicitAny: Not sure what it should be
  any,
  // biome-ignore lint/suspicious/noExplicitAny: Not sure what it should be
  any
> &
  StackRouterOptions;

function PlainScreenNavigator({
  initialRouteName,
  children,
  screenOptions,
}: PlainScreenNavigatorProps) {
  const { state, descriptors, navigation, NavigationContent } =
    useNavigationBuilder<
      StackNavigationState<ParamListBase>,
      StackRouterOptions,
      StackActionHelpers<ParamListBase>,
      NativeStackNavigationOptions,
      NativeStackNavigationEventMap
    >(StackRouter, {
      initialRouteName,
      children,
      screenOptions,
    });

  return (
    <NavigationContent>
      <PlainScreenView
        state={state}
        navigation={navigation}
        descriptors={descriptors}
      />
    </NavigationContent>
  );
}

export const createPlainNavigator =
  createNavigatorFactory(PlainScreenNavigator);
